import Link from "next/link";
import { contactUsFormCall } from "../../services/publicCall";
import publicApiCall from "../../utils/axiosCall";
import React, { useState } from "react";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import { doneForYouContactForm } from "../../data/dropdown";
import Tippy from "@tippyjs/react";

const DoneForYouContactForm = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();

    // Get form data
    const formData = new FormData(event.target);

    // Convert FormData to a plain object
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });
    // Adding a new key-value pair of Subject
    formObject["subject"] = "Impactoverse Contact Query";

    // Log or use the form data as needed
    // console.log(formObject);
    // Convert formObject to JSON string
    const formJson = JSON.stringify(formObject);
    // Log the JSON string
    console.log(formJson);
    // Call your API function here, passing the form data
    // For example, postPublic('/api/contact', formObject);
    try {
      const response = contactUsFormCall(formObject);

      // Handle the API response as needed
      console.log("API Response:", response);
    } catch (error) {
      // Handle API call error
      console.error("API Error:", error);
    }
  };
  return (
    <form id="contact-form" method="post" onSubmit={handleSubmit}>
      <div className="flex space-x-7">
        <div className="mb-6 w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Name<span className="text-red">*</span>
          </label>
          <input
            name="name"
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="name"
            type="text"
            required
          />
        </div>

        <div className="mb-6 w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Email<span className="text-red">*</span>
          </label>
          <input
            name="email"
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="email"
            type="email"
            required
          />
        </div>
      </div>
      <div className="mb-4">
        <div>
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Subject<span className="text-red">*</span>
          </label>
        </div>

        {/* dropdown */}
        <div className="dropdown my-1 cursor-pointer w-auto">
          <Collection_dropdown2
            data={doneForYouContactForm}
            collection={true}
          />
        </div>
      </div>

      <div className="mb-4">
        <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
          Message<span className="text-red">*</span>
        </label>
        <textarea
          id="message"
          className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
          required
          name="message"
          rows="5"
        ></textarea>
      </div>

      <div className="mb-6 flex items-center space-x-2">
        <input
          type="checkbox"
          id="contact-form-consent-input"
          name="optIn"
          className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer"
        />
        <label className="dark:text-jacarta-200 text-sm">
          Click to Opt In to our Newsletter and Updates{" "}
        </label>
      </div>

      <button
        type="submit"
        className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
        id="contact-form-submit"
      >
        Submit
      </button>

      <div
        id="contact-form-notice"
        className="relative mt-4 hidden rounded-lg border border-transparent p-4"
      ></div>
    </form>
  );
};

export default DoneForYouContactForm;
